export const apiCreate = (): string => '/users/menus/create'
export const apiList = (id?: string): string =>
  !id ? '/users/menus/' : `/users/menus/view/${id}`
export const apiUpdate = (id: string): string => `/users/menus/update/${id}`
export const apiDelete = (id: string): string => `/users/menus/delete/${id}`
